import Api from "./Api";
import Csrf from "./Csrf";

export default {
    
  async index() {
    await Csrf.getCookie();

    return Api.get("/coupons");
  },
    
  async store(data) {
    await Csrf.getCookie();

    return Api.post("/coupons",data);
  },
    
  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/coupons/"+id);
  },
	
  async available(data) {
    await Csrf.getCookie();

    return Api.post("/coupons/available",data);
  },
	
};